import Utils from '../../Utils';
import {fieldOptions} from './HealthXref';
import {Parameter} from './Parameter';

class HealthParameter extends Parameter {
    valueAsString = () => {
        return fieldOptions.hasOwnProperty(this.id)
            ? (fieldOptions[this.id as keyof typeof fieldOptions].options
                  .map((o) => o.toString())
                  .find((o: string) => Utils.MakeVarName(o) === this.value.toString()) ?? this.value.toString())
            : this.value.toString();
    };
}

export class Health {
    Bloodpressure: Parameter = new HealthParameter('Bloodpressure');
    Cholesterol: Parameter = new HealthParameter('Cholesterol');
    Type1Diabetes: Parameter = new HealthParameter('Type1Diabetes');
    Type2Diabetes: Parameter = new HealthParameter('Type2Diabetes');
    Anxiety: Parameter = new HealthParameter('Anxiety');
    Depression: Parameter = new HealthParameter('Depression');
    BipolarDisorder: Parameter = new HealthParameter('BipolarDisorder');
    Schizophrenia: Parameter = new HealthParameter('Schizophrenia');
    OsteoArthritis: Parameter = new HealthParameter('OsteoArthritis');
    RheumatoidArthritis: Parameter = new HealthParameter('RheumatoidArthritis');
    Herpes: Parameter = new HealthParameter('Herpes');
    ADDADHD: Parameter = new HealthParameter('ADDADHD');
    AutismSpectrumDisorder: Parameter = new HealthParameter('AutismSpectrumDisorder');
    autismSpectrumDisorderSeverity: Parameter = new HealthParameter('autismSpectrumDisorderSeverity');
    psychNumMedications: Parameter = new HealthParameter('psychNumMedications');
    psychHospitalization: Parameter = new HealthParameter('psychHospitalization');
    Narcolepsy: Parameter = new HealthParameter('Narcolepsy');
    Asthma: Parameter = new HealthParameter('Asthma');
    COPD: Parameter = new HealthParameter('COPD');
    SleepApnea: Parameter = new HealthParameter('SleepApnea');
    HeartFailure: Parameter = new HealthParameter('HeartFailure');
    Osteoperosis: Parameter = new HealthParameter('Osteoperosis');
    EnlargedProstateBenignProstaticHyperplasia: Parameter = new HealthParameter(
        'EnlargedProstateBenignProstaticHyperplasia',
    );
    Gout: Parameter = new HealthParameter('Gout');
    KidneyStones: Parameter = new HealthParameter('KidneyStones');
    ParkinsonsDisease: Parameter = new HealthParameter('ParkinsonsDisease');
    Insomnia: Parameter = new HealthParameter('Insomnia');
    IBSIrritableBowelSyndrome: Parameter = new HealthParameter('IBSIrritableBowelSyndrome');
    Pneumonia: Parameter = new HealthParameter('Pneumonia');
    BreastCancer: Parameter = new HealthParameter('BreastCancer');
    BloodClotinthelungsPulmonaryEmbolism: Parameter = new HealthParameter('BloodClotinthelungsPulmonaryEmbolism');
    DementiaAlzheimers: Parameter = new HealthParameter('DementiaAlzheimers');
    Bronchitis: Parameter = new HealthParameter('Bronchitis');
    UTIUrinaryTractInfection: Parameter = new HealthParameter('UTIUrinaryTractInfection');
    Sexuallytransmitteddiseases: Parameter = new HealthParameter('Sexuallytransmitteddiseases');
    Conjuctiva: Parameter = new HealthParameter('Conjuctiva');
    MSMultipleSclerosis: Parameter = new HealthParameter('MSMultipleSclerosis');
    MuscleSpasms: Parameter = new HealthParameter('MuscleSpasms');
    StaphInfection: Parameter = new HealthParameter('StaphInfection');
    CoronavirusCovid19: Parameter = new HealthParameter('CoronavirusCovid19');
    Eczema: Parameter = new HealthParameter('Eczema');
    ProstateCancer: Parameter = new HealthParameter('ProstateCancer');
    HIVAIDS: Parameter = new HealthParameter('HIVAIDS');
    Glaucoma: Parameter = new HealthParameter('Glaucoma');
    CrohnsDisease: Parameter = new HealthParameter('CrohnsDisease');
    OpioidAddiction: Parameter = new HealthParameter('OpioidAddiction');
    Ulcers: Parameter = new HealthParameter('Ulcers');
    SeizuresEpilepsyPetitMal: Parameter = new HealthParameter('SeizuresEpilepsyPetitMal');
    SeizuresEpilepsyGrandMal: Parameter = new HealthParameter('SeizuresEpilepsyGrandMal');
    AllergiesHayFever: Parameter = new HealthParameter('AllergiesHayFever');
    Stroke: Parameter = new HealthParameter('Stroke');
    YeastInfection: Parameter = new HealthParameter('YeastInfection');
    PainMedication: Parameter = new HealthParameter('PainMedication');
    MuscleRelaxant: Parameter = new HealthParameter('MuscleRelaxant');
    UlcerativeColitis: Parameter = new HealthParameter('UlcerativeColitis');
    GERDHeartburn: Parameter = new HealthParameter('GERDHeartburn');
    Fibromyalgia: Parameter = new HealthParameter('Fibromyalgia');
    HeadachesMigraines: Parameter = new HealthParameter('HeadachesMigraines');
    HBVHepatitisBVirus: Parameter = new HealthParameter('HBVHepatitisBVirus');
    HCVHepatitisCVirus: Parameter = new HealthParameter('HCVHepatitisCVirus');
    Anemia: Parameter = new HealthParameter('Anemia');
    Hyperthyroidism: Parameter = new HealthParameter('Hyperthyroidism');
    Menopause: Parameter = new HealthParameter('Menopause');
    TuberculosisTB: Parameter = new HealthParameter('TuberculosisTB');
    Hypothyroidism: Parameter = new HealthParameter('Hypothyroidism');
    LeftBundleBranchBlock: Parameter = new HealthParameter('LeftBundleBranchBlock');
    RightBundleBranchBlock: Parameter = new HealthParameter('RightBundleBranchBlock');
    Diarrhea: Parameter = new HealthParameter('Diarrhea');
    Meningitis: Parameter = new HealthParameter('Meningitis');
    AddisonsDisease: Parameter = new HealthParameter('AddisonsDisease');
    AdrenogenitalSyndrome: Parameter = new HealthParameter('AdrenogenitalSyndrome');
    Bulimia: Parameter = new HealthParameter('Bulimia');
    OCDObsessiveCompulsiveDisorder: Parameter = new HealthParameter('OCDObsessiveCompulsiveDisorder');
    PagetsDisease: Parameter = new HealthParameter('PagetsDisease');
    BladderInfection: Parameter = new HealthParameter('BladderInfection');
    LiverDisease: Parameter = new HealthParameter('LiverDisease');
    KidneyDisorderKidneyDisease: Parameter = new HealthParameter('KidneyDisorderKidneyDisease');
    RestlessLegSyndromeRLS: Parameter = new HealthParameter('RestlessLegSyndromeRLS');
    Cancer: Parameter = new HealthParameter('Cancer');
    BacterialInfection: Parameter = new HealthParameter('BacterialInfection');
    Leukemia: Parameter = new HealthParameter('Leukemia');
    SkinCancerMelanoma: Parameter = new HealthParameter('SkinCancerMelanoma');
    Hypoglycemia: Parameter = new HealthParameter('Hypoglycemia');
    CysticFibrosis: Parameter = new HealthParameter('CysticFibrosis');
    Nausea: Parameter = new HealthParameter('Nausea');
    TourettesSyndrome: Parameter = new HealthParameter('TourettesSyndrome');
    Lupus: Parameter = new HealthParameter('Lupus');
    Malaria: Parameter = new HealthParameter('Malaria');
    OvarianCancer: Parameter = new HealthParameter('OvarianCancer');
    Lymphoma: Parameter = new HealthParameter('Lymphoma');
    BasalCellCarcinoma: Parameter = new HealthParameter('BasalCellCarcinoma');
    HPV: Parameter = new HealthParameter('HPV');
    Emphysema: Parameter = new HealthParameter('Emphysema');
    TardiveDyskinesia: Parameter = new HealthParameter('TardiveDyskinesia');
    Acne: Parameter = new HealthParameter('Acne');
    FungalInfection: Parameter = new HealthParameter('FungalInfection');
    BirthControl: Parameter = new HealthParameter('BirthControl');
    Myelofibrosis: Parameter = new HealthParameter('Myelofibrosis');
    HormoneReplacementTherapy: Parameter = new HealthParameter('HormoneReplacementTherapy');
    Endometriosis: Parameter = new HealthParameter('Endometriosis');
    Hyperkalemia: Parameter = new HealthParameter('Hyperkalemia');
    PanicDisorder: Parameter = new HealthParameter('PanicDisorder');
    MultipleMyeloma: Parameter = new HealthParameter('MultipleMyeloma');
    Constipation: Parameter = new HealthParameter('Constipation');
    OveractiveBladder: Parameter = new HealthParameter('OveractiveBladder');
    OpioidEmergency: Parameter = new HealthParameter('OpioidEmergency');
    Neutropenia: Parameter = new HealthParameter('Neutropenia');
    IdiopathicPulmonaryFibrosisIPF: Parameter = new HealthParameter('IdiopathicPulmonaryFibrosisIPF');
    WeightLossObesityGastric: Parameter = new HealthParameter('WeightLossObesityGastric');
    InfluenzaFlu: Parameter = new HealthParameter('InfluenzaFlu');
    PostTraumaticStressDisorderPTSD: Parameter = new HealthParameter('PostTraumaticStressDisorderPTSD');
    Hypokalemia: Parameter = new HealthParameter('Hypokalemia');
    Congestion: Parameter = new HealthParameter('Congestion');
    ExcessiveUnderarmSweating: Parameter = new HealthParameter('ExcessiveUnderarmSweating');
    Tumor: Parameter = new HealthParameter('Tumor');
    HeartArrythmia: Parameter = new HealthParameter('HeartArrythmia');
    Shingles: Parameter = new HealthParameter('Shingles');
    ChronicDryEye: Parameter = new HealthParameter('ChronicDryEye');
    TetanusLockjaw: Parameter = new HealthParameter('TetanusLockjaw');
    ErectileDysfunction: Parameter = new HealthParameter('ErectileDysfunction');
    Transplant: Parameter = new HealthParameter('Transplant');
    Defibrillator: Parameter = new HealthParameter('Defibrillator');
    Cough: Parameter = new HealthParameter('Cough');
    CirrhosisoftheLiver: Parameter = new HealthParameter('CirrhosisoftheLiver');
    UrinaryRetention: Parameter = new HealthParameter('UrinaryRetention');
    Gallstones: Parameter = new HealthParameter('Gallstones');
    SmokingCessationQuitSmoking: Parameter = new HealthParameter('SmokingCessationQuitSmoking');
    EatingDisorder: Parameter = new HealthParameter('EatingDisorder');
    ChronicHives: Parameter = new HealthParameter('ChronicHives');
    Polyps: Parameter = new HealthParameter('Polyps');
    ObstructiveAirwayDisease: Parameter = new HealthParameter('ObstructiveAirwayDisease');
    Cataplexy: Parameter = new HealthParameter('Cataplexy');
    PleuralMesothelioma: Parameter = new HealthParameter('PleuralMesothelioma');
    bpDiagnosisDate: Parameter = new HealthParameter('bpDiagnosisDate');
    bpNumMedications: Parameter = new HealthParameter('bpNumMedications');
    bpReadingLow: Parameter = new HealthParameter('bpReadingLow');
    bpReadingHigh: Parameter = new HealthParameter('bpReadingHigh');
    bpMedications: Parameter = new HealthParameter('bpMedications');
    cholesterolDiagnosisDate: Parameter = new HealthParameter('cholesterolDiagnosisDate');
    cholesterolMedications: Parameter = new HealthParameter('cholesterolMedications');
    cholesterolChecked: Parameter = new HealthParameter('cholesterolChecked');
    cholesterolReading: Parameter = new HealthParameter('cholesterolReading');
    cholesterolReadingAlt: Parameter = new HealthParameter('cholesterolReadingAlt');
    type1DiagnosisDate: Parameter = new HealthParameter('type1DiagnosisDate');
    type1A1CReading: Parameter = new HealthParameter('type1A1CReading');
    type1Treatment: Parameter = new HealthParameter('type1Treatment');
    type1Complications: Parameter = new HealthParameter('type1Complications');
    type2DiagnosisDate: Parameter = new HealthParameter('type2DiagnosisDate');
    type2A1CReading: Parameter = new HealthParameter('type2A1CReading');
    type2Treatment: Parameter = new HealthParameter('type2Treatment');
    type2Complications: Parameter = new HealthParameter('type2Complications');
    type2DiagnosisAge: Parameter = new HealthParameter('type2DiagnosisAge');
    anxietyDiagnosisDate: Parameter = new HealthParameter('anxietyDiagnosisDate');
    anxietySeverity: Parameter = new HealthParameter('anxietySeverity');
    anxietyMedications: Parameter = new HealthParameter('anxietyMedications');
    anxietyHospilization: Parameter = new HealthParameter('anxietyHospilization');
    anxietyTreatment: Parameter = new HealthParameter('anxietyTreatment');
    anxietySuicideAttempts: Parameter = new HealthParameter('anxietySuicideAttempts');
    depressionDiagnosisDate: Parameter = new HealthParameter('depressionDiagnosisDate');
    depressionSeverity: Parameter = new HealthParameter('depressionSeverity');
    depressionHospitalizations: Parameter = new HealthParameter('depressionHospitalizations');
    depressionTreatment: Parameter = new HealthParameter('depressionTreatment');
    depressionInpatient: Parameter = new HealthParameter('depressionInpatient');
    depressionSuicideAttempts: Parameter = new HealthParameter('depressionSuicideAttempts');
    bipolarDiagnosisDate: Parameter = new HealthParameter('bipolarDiagnosisDate');
    bipolarMedications: Parameter = new HealthParameter('bipolarMedications');
    bipolarYearsStable: Parameter = new HealthParameter('bipolarYearsStable');
    bipolarHospitalizations: Parameter = new HealthParameter('bipolarHospitalizations');
    schizophreniaDiagnosisDate: Parameter = new HealthParameter('schizophreniaDiagnosisDate');
    schizophreniaMedications: Parameter = new HealthParameter('schizophreniaMedications');
    schizophreniaYearsStable: Parameter = new HealthParameter('schizophreniaYearsStable');
    schizophreniaHospitalizations: Parameter = new HealthParameter('schizophreniaHospitalizations');
    osteoarthritisDiagnosisDate: Parameter = new HealthParameter('osteoarthritisDiagnosisDate');
    osteoarthritisTreatment: Parameter = new HealthParameter('osteoarthritisTreatment');
    osteoarthritisSideEffects: Parameter = new HealthParameter('osteoarthritisSideEffects');
    rheumatoidarthritisDiagnosisDate: Parameter = new HealthParameter('rheumatoidarthritisDiagnosisDate');
    rhuematoidarthritisImmunoMedication: Parameter = new HealthParameter('rhuematoidarthritisImmunoMedication');
    rheumatoidarthritisSideEffects: Parameter = new HealthParameter('rheumatoidarthritisSideEffects');
    rheumatoidarthritisTreatment: Parameter = new HealthParameter('rheumatoidarthritisTreatment');
    herpesDiagnosisDate: Parameter = new HealthParameter('herpesDiagnosisDate');
    herpesPendingDiagnosis: Parameter = new HealthParameter('herpesPendingDiagnosis');
    addDiagnosisDate: Parameter = new HealthParameter('addDiagnosisDate');
    addYearsStable: Parameter = new HealthParameter('addYearsStable');
    addSideEffects: Parameter = new HealthParameter('addSideEffects');
    addTreatment: Parameter = new HealthParameter('addTreatment');
    narcolepsyDiagnosisDate: Parameter = new HealthParameter('narcolepsyDiagnosisDate');
    narcolepsyPendingDiagnosis: Parameter = new HealthParameter('narcolepsyPendingDiagnosis');
    asthmaDiagnosisDate: Parameter = new HealthParameter('asthmaDiagnosisDate');
    asthmaSeverity: Parameter = new HealthParameter('asthmaSeverity');
    asthmaHospitalizations: Parameter = new HealthParameter('asthmaHospitalizations');
    asthmaSteroids: Parameter = new HealthParameter('asthmaSteroids');
    copdDiagnosisDate: Parameter = new HealthParameter('copdDiagnosisDate');
    copdOxygenUsage: Parameter = new HealthParameter('copdOxygenUsage');
    copdSymptoms: Parameter = new HealthParameter('copdSymptoms');
    copdMedications: Parameter = new HealthParameter('copdMedications');
    sleepapneaDiagnosisDate: Parameter = new HealthParameter('sleepapneaDiagnosisDate');
    sleepapneaSeverity: Parameter = new HealthParameter('sleepapneaSeverity');
    sleepapneaTreatment: Parameter = new HealthParameter('sleepapneaTreatment');
    heartfailureDiagnosisAge: Parameter = new HealthParameter('heartfailureDiagnosisAge');
    heartfailureBloodThinners: Parameter = new HealthParameter('heartfailureBloodThinners');
    heartfailureSurgery: Parameter = new HealthParameter('heartfailureSurgery');
    heartfailureTreatment: Parameter = new HealthParameter('heartfailureTreatment');
    heartfailureCardiologistVisit: Parameter = new HealthParameter('heartfailureCardiologistVisit');
    osteoperosisDiagnosisDate: Parameter = new HealthParameter('osteoperosisDiagnosisDate');
    osteoperosisConditions: Parameter = new HealthParameter('osteoperosisConditions');
    osteoperosisTreatment: Parameter = new HealthParameter('osteoperosisTreatment');
    enlargedprostateDiagnosisDate: Parameter = new HealthParameter('enlargedprostateDiagnosisDate');
    enlargedprostatePendingDiagnosis: Parameter = new HealthParameter('enlargedprostatePendingDiagnosis');
    enlargedprostateCancerous: Parameter = new HealthParameter('enlargedprostateCancerous');
    enlargedprostateEvaluations: Parameter = new HealthParameter('enlargedprostateEvaluations');
    enlargedprostateDiagnosis: Parameter = new HealthParameter('enlargedprostateDiagnosis');
    enlargedprostateTreatment: Parameter = new HealthParameter('enlargedprostateTreatment');
    goutDiagnosisDate: Parameter = new HealthParameter('goutDiagnosisDate');
    goutPendingDiagnosis: Parameter = new HealthParameter('goutPendingDiagnosis');
    goutTreatmentPlan: Parameter = new HealthParameter('goutTreatmentPlan');
    kidneystonesDiagnosisDate: Parameter = new HealthParameter('kidneystonesDiagnosisDate');
    kidneystonesResolved: Parameter = new HealthParameter('kidneystonesResolved');
    parkinsonsDiagnosisDate: Parameter = new HealthParameter('parkinsonsDiagnosisDate');
    parkinsonsTreatment: Parameter = new HealthParameter('parkinsonsTreatment');
    insomniaDiagnosisDate: Parameter = new HealthParameter('insomniaDiagnosisDate');
    insomniaResults: Parameter = new HealthParameter('insomniaResults');
    ventriculartachycardiaDiagnosisDate: Parameter = new HealthParameter('ventriculartachycardiaDiagnosisDate');
    ventriculartachycardiaTreatmentPlan: Parameter = new HealthParameter('ventriculartachycardiaTreatmentPlan');
    ventriculartachycardiaSymptoms: Parameter = new HealthParameter('ventriculartachycardiaSymptoms');
    ventriculartachycardiaAblation: Parameter = new HealthParameter('ventriculartachycardiaAblation');
    vFibDiagnosisDate: Parameter = new HealthParameter('vFibDiagnosisDate');
    vFibTreatment: Parameter = new HealthParameter('vFibTreatment');
    vFibSurgeryDate: Parameter = new HealthParameter('vFibSurgeryDate');
    vFibSymptoms: Parameter = new HealthParameter('vFibSymptoms');
    vFibAblationDate: Parameter = new HealthParameter('vFibAblationDate');
    ibsDiagnosisDate: Parameter = new HealthParameter('ibsDiagnosisDate');
    ibsCondition: Parameter = new HealthParameter('ibsCondition');
    ibsTreatment: Parameter = new HealthParameter('ibsTreatment');
    pneumoniaDiagnosisDate: Parameter = new HealthParameter('pneumoniaDiagnosisDate');
    pneumoniaTreatmentCompleted: Parameter = new HealthParameter('pneumoniaTreatmentCompleted');
    parkinsonsSymptoms: Parameter = new HealthParameter('parkinsonsSymptoms');
    breastcancerYearsRemission: Parameter = new HealthParameter('breastcancerYearsRemission');
    breastcancerTypeStage: Parameter = new HealthParameter('breastcancerTypeStage');
    breastcancerTreatment: Parameter = new HealthParameter('breastcancerTreatment');
    afibDiagnosisDate: Parameter = new HealthParameter('afibDiagnosisDate');
    afibAblation: Parameter = new HealthParameter('afibAblation');
    afibResolved: Parameter = new HealthParameter('afibResolved');
    afibEpisodes: Parameter = new HealthParameter('afibEpisodes');
    afibHeartDisease: Parameter = new HealthParameter('afibHeartDisease');
    pulmonaryembolismDiagnosisDate: Parameter = new HealthParameter('pulmonaryembolismDiagnosisDate');
    pulmonaryembolismSymptoms: Parameter = new HealthParameter('pulmonaryembolismSymptoms');
    pulmonaryembolismTreatment: Parameter = new HealthParameter('pulmonaryembolismTreatment');
    dvtDiagnosisDate: Parameter = new HealthParameter('dvtDiagnosisDate');
    dvtResolved: Parameter = new HealthParameter('dvtResolved');
    dvtEpisodes: Parameter = new HealthParameter('dvtEpisodes');
    dvtLastEpisode: Parameter = new HealthParameter('dvtLastEpisode');
    dvtTreatment: Parameter = new HealthParameter('dvtTreatment');
    alzheimersDiagnosis: Parameter = new HealthParameter('alzheimersDiagnosis');
    bronchitisDiagnosisDate: Parameter = new HealthParameter('bronchitisDiagnosisDate');
    bronchitisChronic: Parameter = new HealthParameter('bronchitisChronic');
    bronchitisEpisodes: Parameter = new HealthParameter('bronchitisEpisodes');
    bronchitisRecovery: Parameter = new HealthParameter('bronchitisRecovery');
    bronchitisSymptoms: Parameter = new HealthParameter('bronchitisSymptoms');
    bronchitisTreatment: Parameter = new HealthParameter('bronchitisTreatment');
    utiDiagnosisDate: Parameter = new HealthParameter('utiDiagnosisDate');
    utiPendingDiagnsois: Parameter = new HealthParameter('utiPendingDiagnsois');
    utiEpisodes: Parameter = new HealthParameter('utiEpisodes');
    utiRecovery: Parameter = new HealthParameter('utiRecovery');
    stdDiagnosisDate: Parameter = new HealthParameter('stdDiagnosisDate');
    conjuctivaDiagnosisDate: Parameter = new HealthParameter('conjuctivaDiagnosisDate');
    multiplesclerosisDiagnosis: Parameter = new HealthParameter('multiplesclerosisDiagnosis');
    multiplesclerosisDailyLivingActivities: Parameter = new HealthParameter('multiplesclerosisDailyLivingActivities');
    multiplesclerosisTreatment: Parameter = new HealthParameter('multiplesclerosisTreatment');
    musclespasmsDiagnosisDate: Parameter = new HealthParameter('musclespasmsDiagnosisDate');
    musclespasmsPendingDiagnosis: Parameter = new HealthParameter('musclespasmsPendingDiagnosis');
    musclespasmsSypmtoms: Parameter = new HealthParameter('musclespasmsSypmtoms');
    musclespasmsContinualSymptoms: Parameter = new HealthParameter('musclespasmsContinualSymptoms');
    staphDiagnosisDate: Parameter = new HealthParameter('staphDiagnosisDate');
    covidDiagnosisDate: Parameter = new HealthParameter('covidDiagnosisDate');
    eczemaDiagnosis: Parameter = new HealthParameter('eczemaDiagnosis');
    eczemaDiagnosisDate: Parameter = new HealthParameter('eczemaDiagnosisDate');
    exzemaTreatment: Parameter = new HealthParameter('exzemaTreatment');
    psoriasisDiagnosisDate: Parameter = new HealthParameter('psoriasisDiagnosisDate');
    psoriasisPendingDiagnosis: Parameter = new HealthParameter('psoriasisPendingDiagnosis');
    psoriasisOralMedications: Parameter = new HealthParameter('psoriasisOralMedications');
    psoriasisTreatmentPlan: Parameter = new HealthParameter('psoriasisTreatmentPlan');
    prostatecancerRemission: Parameter = new HealthParameter('prostatecancerRemission');
    prostatecancerDiagnosisDate: Parameter = new HealthParameter('prostatecancerDiagnosisDate');
    prostatecancerDiagnosisAge: Parameter = new HealthParameter('prostatecancerDiagnosisAge');
    prostatecancerRecovery: Parameter = new HealthParameter('prostatecancerRecovery');
    prostatecancerTypeStage: Parameter = new HealthParameter('prostatecancerTypeStage');
    prostatecancerTreatment: Parameter = new HealthParameter('prostatecancerTreatment');
    hivDiagnosis: Parameter = new HealthParameter('hivDiagnosis');
    hivDiagnosisDate: Parameter = new HealthParameter('hivDiagnosisDate');
    hivTreatment: Parameter = new HealthParameter('hivTreatment');
    glaucomaDiagnosis: Parameter = new HealthParameter('glaucomaDiagnosis');
    glaucomaDiagnosisDate: Parameter = new HealthParameter('glaucomaDiagnosisDate');
    glaucomaTreatment: Parameter = new HealthParameter('glaucomaTreatment');
    chrohnsdiseaseDiagnosisDate: Parameter = new HealthParameter('chrohnsdiseaseDiagnosisDate');
    chronsdiseaseColonscopy: Parameter = new HealthParameter('chronsdiseaseColonscopy');
    crohnsdiseaseTreatmentPlan: Parameter = new HealthParameter('crohnsdiseaseTreatmentPlan');
    chronsdiseaseSymptoms: Parameter = new HealthParameter('chronsdiseaseSymptoms');
    opiodSobriertyYears: Parameter = new HealthParameter('opiodSobriertyYears');
    opiodaddictionAAMember: Parameter = new HealthParameter('opiodaddictionAAMember');
    ulcerDiagnosisDate: Parameter = new HealthParameter('ulcerDiagnosisDate');
    ulcerEpisodes: Parameter = new HealthParameter('ulcerEpisodes');
    ulcerTreatment: Parameter = new HealthParameter('ulcerTreatment');
    ulcerSurgery3: Parameter = new HealthParameter('ulcerSurgery3');
    ulcerSurgery2: Parameter = new HealthParameter('ulcerSurgery2');
    ulcerSurgery1: Parameter = new HealthParameter('ulcerSurgery1');
    ulcerSurgery: Parameter = new HealthParameter('ulcerSurgery');
    petitmalDiagnosisDate: Parameter = new HealthParameter('petitmalDiagnosisDate');
    petitmalRecentSeizures: Parameter = new HealthParameter('petitmalRecentSeizures');
    petitmalTreatment: Parameter = new HealthParameter('petitmalTreatment');
    grandmalDiagnosisDate: Parameter = new HealthParameter('grandmalDiagnosisDate');
    grandmalRecentSeizures: Parameter = new HealthParameter('grandmalRecentSeizures');
    grandmalTreatment: Parameter = new HealthParameter('grandmalTreatment');
    allergiesSeasonality: Parameter = new HealthParameter('allergiesSeasonality');
    allergiesSeverity: Parameter = new HealthParameter('allergiesSeverity');
    allergiesHospitalizations: Parameter = new HealthParameter('allergiesHospitalizations');
    allergiesTreatmentPlan: Parameter = new HealthParameter('allergiesTreatmentPlan');
    strokeDiagnosisDate: Parameter = new HealthParameter('strokeDiagnosisDate');
    strokeAge: Parameter = new HealthParameter('strokeAge');
    strokeLastOccurence: Parameter = new HealthParameter('strokeLastOccurence');
    strokeTotalOccurence: Parameter = new HealthParameter('strokeTotalOccurence');
    strokeTreatmentSymptoms: Parameter = new HealthParameter('strokeTreatmentSymptoms');
    yeastinfectionDiagnosisDate: Parameter = new HealthParameter('yeastinfectionDiagnosisDate');
    painmedicationNumber: Parameter = new HealthParameter('painmedicationNumber');
    painmedicationEmployment: Parameter = new HealthParameter('painmedicationEmployment');
    musclerelaxantDiagnosisDate: Parameter = new HealthParameter('musclerelaxantDiagnosisDate');
    ulcerativecolitisDiagnosisYears: Parameter = new HealthParameter('ulcerativecolitisDiagnosisYears');
    coloscopyCompletedRecently: Parameter = new HealthParameter('coloscopyCompletedRecently');
    ulcerativecolitisSymptoms: Parameter = new HealthParameter('ulcerativecolitisSymptoms');
    ulcerativecolitisTreatment: Parameter = new HealthParameter('ulcerativecolitisTreatment');
    gerdDiagnosisDate: Parameter = new HealthParameter('gerdDiagnosisDate');
    gerdComplications: Parameter = new HealthParameter('gerdComplications');
    gerdBiopsyCompleted: Parameter = new HealthParameter('gerdBiopsyCompleted');
    gerdBiopsyResults: Parameter = new HealthParameter('gerdBiopsyResults');
    gerdTreatmentPlan: Parameter = new HealthParameter('gerdTreatmentPlan');
    anginaDiagnosisDate: Parameter = new HealthParameter('anginaDiagnosisDate');
    anginaEvaluation: Parameter = new HealthParameter('anginaEvaluation');
    anginaTreatment: Parameter = new HealthParameter('anginaTreatment');
    fibromyalgiaDiagnosisDate: Parameter = new HealthParameter('fibromyalgiaDiagnosisDate');
    fibromyalgiaPendingDiagnosis: Parameter = new HealthParameter('fibromyalgiaPendingDiagnosis');
    fibromyalgiaSideEffects: Parameter = new HealthParameter('fibromyalgiaSideEffects');
    migraineDiagnosisDate: Parameter = new HealthParameter('migraineDiagnosisDate');
    migrainePendingDiagnosis: Parameter = new HealthParameter('migrainePendingDiagnosis');
    migrainesSideEffects: Parameter = new HealthParameter('migrainesSideEffects');
    hepbDiagnosis: Parameter = new HealthParameter('hepbDiagnosis');
    hepbDiagnosisDate: Parameter = new HealthParameter('hepbDiagnosisDate');
    hepbLiverBiopsy: Parameter = new HealthParameter('hepbLiverBiopsy');
    hepBTreatmentPlan: Parameter = new HealthParameter('hepBTreatmentPlan');
    hepbUltrasound: Parameter = new HealthParameter('hepbUltrasound');
    hepcDiagnosis: Parameter = new HealthParameter('hepcDiagnosis');
    hepcDiagnosisDate: Parameter = new HealthParameter('hepcDiagnosisDate');
    hepcLiverBiopsy: Parameter = new HealthParameter('hepcLiverBiopsy');
    hepcTreatmentPlan: Parameter = new HealthParameter('hepcTreatmentPlan');
    hepcUltrasound: Parameter = new HealthParameter('hepcUltrasound');
    anemiaDiagnosisDate: Parameter = new HealthParameter('anemiaDiagnosisDate');
    anemiaPendingDiagnosis: Parameter = new HealthParameter('anemiaPendingDiagnosis');
    anemiaTreatmentPlan: Parameter = new HealthParameter('anemiaTreatmentPlan');
    thyroidDiagnosisDate: Parameter = new HealthParameter('thyroidDiagnosisDate');
    thyroidMalignant: Parameter = new HealthParameter('thyroidMalignant');
    thyroidPendingDiagnosis: Parameter = new HealthParameter('thyroidPendingDiagnosis');
    thyroidSymptoms: Parameter = new HealthParameter('thyroidSymptoms');
    menopauseDiagnosisDate: Parameter = new HealthParameter('menopauseDiagnosisDate');
    tuberculosisDiagnosisDate: Parameter = new HealthParameter('tuberculosisDiagnosisDate');
    tuberculosisTreatmentCompleted: Parameter = new HealthParameter('tuberculosisTreatmentCompleted');
    hypothyroidismDiagnosisDate: Parameter = new HealthParameter('hypothyroidismDiagnosisDate');
    hypthyroidismMalignant: Parameter = new HealthParameter('hypthyroidismMalignant');
    hypothyroidismPendingDiagnosis: Parameter = new HealthParameter('hypothyroidismPendingDiagnosis');
    hypothyroidismMedications: Parameter = new HealthParameter('hypothyroidismMedications');
    lbbbDiagnosisDate: Parameter = new HealthParameter('lbbbDiagnosisDate');
    lbbbAblationDate: Parameter = new HealthParameter('lbbbAblationDate');
    lbbbSymptoms: Parameter = new HealthParameter('lbbbSymptoms');
    lbbbTreatmentPlan: Parameter = new HealthParameter('lbbbTreatmentPlan');
    rbbbDiagnosisDate: Parameter = new HealthParameter('rbbbDiagnosisDate');
    rbbbAblationDate: Parameter = new HealthParameter('rbbbAblationDate');
    rbbbSymptoms: Parameter = new HealthParameter('rbbbSymptoms');
    rbbbTreatmentPlan: Parameter = new HealthParameter('rbbbTreatmentPlan');
    avblockDiagnosisDate: Parameter = new HealthParameter('avblockDiagnosisDate');
    avblockTreatmentPlan: Parameter = new HealthParameter('avblockTreatmentPlan');
    avblockAblation: Parameter = new HealthParameter('avblockAblation');
    avblockSymptoms: Parameter = new HealthParameter('avblockSymptoms');
    diarrheaDiagnosisDate: Parameter = new HealthParameter('diarrheaDiagnosisDate');
    diarrheaPendingDiagnosis: Parameter = new HealthParameter('diarrheaPendingDiagnosis');
    diarrheaTreatmentPlan: Parameter = new HealthParameter('diarrheaTreatmentPlan');
    meningitisDiagnosisDate: Parameter = new HealthParameter('meningitisDiagnosisDate');
    addisondiseaseDiagnosisDate: Parameter = new HealthParameter('addisondiseaseDiagnosisDate');
    addisondiseasePendingDiagnosis: Parameter = new HealthParameter('addisondiseasePendingDiagnosis');
    addisondiseaseSymptoms: Parameter = new HealthParameter('addisondiseaseSymptoms');
    addisondiseaseTreatmentPlan: Parameter = new HealthParameter('addisondiseaseTreatmentPlan');
    adrenogenitalsyndromeDiagnosisDate: Parameter = new HealthParameter('adrenogenitalsyndromeDiagnosisDate');
    bulimiaDiagnosisDate: Parameter = new HealthParameter('bulimiaDiagnosisDate');
    bulimiaTreatmentPlan: Parameter = new HealthParameter('bulimiaTreatmentPlan');
    bulimiaCounseling: Parameter = new HealthParameter('bulimiaCounseling');
    bulimiaHospitalization: Parameter = new HealthParameter('bulimiaHospitalization');
    ocdDiagnosisDate: Parameter = new HealthParameter('ocdDiagnosisDate');
    ocdCondition: Parameter = new HealthParameter('ocdCondition');
    ocdTreatment: Parameter = new HealthParameter('ocdTreatment');
    ocdEvaluations: Parameter = new HealthParameter('ocdEvaluations');
    pagetDiagnosisDate: Parameter = new HealthParameter('pagetDiagnosisDate');
    pagetCondition: Parameter = new HealthParameter('pagetCondition');
    pagetSymptoms: Parameter = new HealthParameter('pagetSymptoms');
    pagetBones: Parameter = new HealthParameter('pagetBones');
    pagetComplications: Parameter = new HealthParameter('pagetComplications');
    pagetComplicationDetails: Parameter = new HealthParameter('pagetComplicationDetails');
    pagetSymptomDetails: Parameter = new HealthParameter('pagetSymptomDetails');
    bladderinfectionDiagnosisDate: Parameter = new HealthParameter('bladderinfectionDiagnosisDate');
    bladderinfectionPendingTreatment: Parameter = new HealthParameter('bladderinfectionPendingTreatment');
    bladderinfectionTreatmentPlan: Parameter = new HealthParameter('bladderinfectionTreatmentPlan');
    liverdiseaseDiagnosis: Parameter = new HealthParameter('liverdiseaseDiagnosis');
    liverdiseaseBiopsy: Parameter = new HealthParameter('liverdiseaseBiopsy');
    liverdiseaseTreatment: Parameter = new HealthParameter('liverdiseaseTreatment');
    kidneydiseaseDiagnosisDate: Parameter = new HealthParameter('kidneydiseaseDiagnosisDate');
    kidneydiseaseDialysis: Parameter = new HealthParameter('kidneydiseaseDialysis');
    kidneydiseaseTreatmentPlan: Parameter = new HealthParameter('kidneydiseaseTreatmentPlan');
    rlsDiagnosisDate: Parameter = new HealthParameter('rlsDiagnosisDate');
    cancerDiagnosisDate: Parameter = new HealthParameter('cancerDiagnosisDate');
    cancerRemissionYears: Parameter = new HealthParameter('cancerRemissionYears');
    cancerType: Parameter = new HealthParameter('cancerType');
    cancerStage: Parameter = new HealthParameter('cancerStage');
    bacterialinfectionDiagnosisDate: Parameter = new HealthParameter('bacterialinfectionDiagnosisDate');
    leukemiaDiagnosisDate: Parameter = new HealthParameter('leukemiaDiagnosisDate');
    leukemiaTreatmentPlan: Parameter = new HealthParameter('leukemiaTreatmentPlan');
    leukemiaRecovery: Parameter = new HealthParameter('leukemiaRecovery');
    melanomaDiagnosisDate: Parameter = new HealthParameter('melanomaDiagnosisDate');
    melanomaStage: Parameter = new HealthParameter('melanomaStage');
    melanomaTreatmentPlan: Parameter = new HealthParameter('melanomaTreatmentPlan');
    melanomaRecovery: Parameter = new HealthParameter('melanomaRecovery');
    hypoglycemiaDiagnosisDate: Parameter = new HealthParameter('hypoglycemiaDiagnosisDate');
    hypoglycemiaHistory: Parameter = new HealthParameter('hypoglycemiaHistory');
    hypoglycemiaCondition: Parameter = new HealthParameter('hypoglycemiaCondition');
    hypoglycemiaA1C: Parameter = new HealthParameter('hypoglycemiaA1C');
    hypoglycemiaLastEpisode: Parameter = new HealthParameter('hypoglycemiaLastEpisode');
    hypoglycemiaTreatment: Parameter = new HealthParameter('hypoglycemiaTreatment');
    cysticfibrosisDiagnosis: Parameter = new HealthParameter('cysticfibrosisDiagnosis');
    cysticfibrosisDiagnosisDate: Parameter = new HealthParameter('cysticfibrosisDiagnosisDate');
    nauseaDiagnosisDate: Parameter = new HealthParameter('nauseaDiagnosisDate');
    tourettesDiagnosisDate: Parameter = new HealthParameter('tourettesDiagnosisDate');
    lupusDiagnosisDate: Parameter = new HealthParameter('lupusDiagnosisDate');
    lupusSideEffects: Parameter = new HealthParameter('lupusSideEffects');
    lupusRecovery: Parameter = new HealthParameter('lupusRecovery');
    lupusComplications: Parameter = new HealthParameter('lupusComplications');
    lupusTreatmentPlan: Parameter = new HealthParameter('lupusTreatmentPlan');
    malariaDiagnosisDate: Parameter = new HealthParameter('malariaDiagnosisDate');
    malariaEpisodes: Parameter = new HealthParameter('malariaEpisodes');
    malariaSymptoms: Parameter = new HealthParameter('malariaSymptoms');
    malariaRecovery: Parameter = new HealthParameter('malariaRecovery');
    ovariancancerDiangosisDate: Parameter = new HealthParameter('ovariancancerDiangosisDate');
    ovariancancerRemissionYears: Parameter = new HealthParameter('ovariancancerRemissionYears');
    ovariancancerStage: Parameter = new HealthParameter('ovariancancerStage');
    ovariancancerTreatmentPlan: Parameter = new HealthParameter('ovariancancerTreatmentPlan');
    ovariancancerRecovery: Parameter = new HealthParameter('ovariancancerRecovery');
    lympohomaDiagnosisDate: Parameter = new HealthParameter('lympohomaDiagnosisDate');
    lymphomaTypeStage: Parameter = new HealthParameter('lymphomaTypeStage');
    lymphomaTreatmentPlan: Parameter = new HealthParameter('lymphomaTreatmentPlan');
    lymphomaRecovery: Parameter = new HealthParameter('lymphomaRecovery');
    basalcellDiagnosisDate: Parameter = new HealthParameter('basalcellDiagnosisDate');
    basalcellRecovery: Parameter = new HealthParameter('basalcellRecovery');
    basalcellMelanoma: Parameter = new HealthParameter('basalcellMelanoma');
    hpvDianosisDate: Parameter = new HealthParameter('hpvDianosisDate');
    hpvTreatmentPlan: Parameter = new HealthParameter('hpvTreatmentPlan');
    hpvCurrentSymptoms: Parameter = new HealthParameter('hpvCurrentSymptoms');
    emphysemaDiagnosisDate: Parameter = new HealthParameter('emphysemaDiagnosisDate');
    emphysemaResolved: Parameter = new HealthParameter('emphysemaResolved');
    emphysemaTreatment: Parameter = new HealthParameter('emphysemaTreatment');
    emphysemaTreatmentPlan: Parameter = new HealthParameter('emphysemaTreatmentPlan');
    tardiveDiagnosisDate: Parameter = new HealthParameter('tardiveDiagnosisDate');
    acneDiagnosisDate: Parameter = new HealthParameter('acneDiagnosisDate');
    fungalinfectionDiagnosisDate: Parameter = new HealthParameter('fungalinfectionDiagnosisDate');
    birthcontrolPrescribedDate: Parameter = new HealthParameter('birthcontrolPrescribedDate');
    myelofibrosisDiagnosisDate: Parameter = new HealthParameter('myelofibrosisDiagnosisDate');
    hormonereplacementDiagnoisDate: Parameter = new HealthParameter('hormonereplacementDiagnoisDate');
    endometriosisDiagnoisDate: Parameter = new HealthParameter('endometriosisDiagnoisDate');
    endometriosisPendingDiangosis: Parameter = new HealthParameter('endometriosisPendingDiangosis');
    endometriosisTreatmentPlan: Parameter = new HealthParameter('endometriosisTreatmentPlan');
    hyperkalemiaDiagnosisDate: Parameter = new HealthParameter('hyperkalemiaDiagnosisDate');
    hyperkalemiaElevatedSugar: Parameter = new HealthParameter('hyperkalemiaElevatedSugar');
    hyperkalemiaHemoglobinTest: Parameter = new HealthParameter('hyperkalemiaHemoglobinTest');
    hyperkalemiaHbA1C: Parameter = new HealthParameter('hyperkalemiaHbA1C');
    hyperkalemiaRecentEpisode: Parameter = new HealthParameter('hyperkalemiaRecentEpisode');
    hyperkalemiaTreatmentPlan: Parameter = new HealthParameter('hyperkalemiaTreatmentPlan');
    panicdisorderDiagnosisDate: Parameter = new HealthParameter('panicdisorderDiagnosisDate');
    panicdisorderTreatmentPlan: Parameter = new HealthParameter('panicdisorderTreatmentPlan');
    panicdisorderCounseling: Parameter = new HealthParameter('panicdisorderCounseling');
    panicDisorderSymptoms: Parameter = new HealthParameter('panicDisorderSymptoms');
    multiplemyelomaDiagnosisDate: Parameter = new HealthParameter('multiplemyelomaDiagnosisDate');
    multiplemyelomaTreatmentPlan: Parameter = new HealthParameter('multiplemyelomaTreatmentPlan');
    multiplemyelomaBloodWork: Parameter = new HealthParameter('multiplemyelomaBloodWork');
    multiplemyelomaRecovery: Parameter = new HealthParameter('multiplemyelomaRecovery');
    constipationDiagnosisDate: Parameter = new HealthParameter('constipationDiagnosisDate');
    constipationPendingDiagnosis: Parameter = new HealthParameter('constipationPendingDiagnosis');
    constipationTreatmentPlan: Parameter = new HealthParameter('constipationTreatmentPlan');
    overactivebladderDiagnosisDate: Parameter = new HealthParameter('overactivebladderDiagnosisDate');
    overactivebladderTreatmentPlan: Parameter = new HealthParameter('overactivebladderTreatmentPlan');
    overactivebladderSymptoms: Parameter = new HealthParameter('overactivebladderSymptoms');
    opioidDiagnosisDate: Parameter = new HealthParameter('opioidDiagnosisDate');
    opioidTreament: Parameter = new HealthParameter('opioidTreament');
    opioidDrugFree: Parameter = new HealthParameter('opioidDrugFree');
    opioidTreatmentDetails: Parameter = new HealthParameter('opioidTreatmentDetails');
    opioidMember: Parameter = new HealthParameter('opioidMember');
    neutropeniaDiagnosisDate: Parameter = new HealthParameter('neutropeniaDiagnosisDate');
    neutropeniaTreatmentPlan: Parameter = new HealthParameter('neutropeniaTreatmentPlan');
    neutropeniaLabWork: Parameter = new HealthParameter('neutropeniaLabWork');
    neutropeniaRecovery: Parameter = new HealthParameter('neutropeniaRecovery');
    fibrosisDiagnosisDate: Parameter = new HealthParameter('fibrosisDiagnosisDate');
    fibrosisTreatmentPlan: Parameter = new HealthParameter('fibrosisTreatmentPlan');
    fibrosisCurrentSymptoms: Parameter = new HealthParameter('fibrosisCurrentSymptoms');
    gastricbypassSurgeryDate: Parameter = new HealthParameter('gastricbypassSurgeryDate');
    fluDiagnosisDate: Parameter = new HealthParameter('fluDiagnosisDate');
    fluCurrentSymptoms: Parameter = new HealthParameter('fluCurrentSymptoms');
    fluRecovery: Parameter = new HealthParameter('fluRecovery');
    ptsdDiagnosisDate: Parameter = new HealthParameter('ptsdDiagnosisDate');
    ptsdSeverity: Parameter = new HealthParameter('ptsdSeverity');
    ptsdInpatient: Parameter = new HealthParameter('ptsdInpatient');
    ptsdInpatientDate: Parameter = new HealthParameter('ptsdInpatientDate');
    ptsdSideEffects: Parameter = new HealthParameter('ptsdSideEffects');
    ptsdTreatmentPlan: Parameter = new HealthParameter('ptsdTreatmentPlan');
    hypokalemiaDiagnosisDate: Parameter = new HealthParameter('hypokalemiaDiagnosisDate');
    hypokalemiaElevatedSugar: Parameter = new HealthParameter('hypokalemiaElevatedSugar');
    hypokalemiaHemoglobinTest: Parameter = new HealthParameter('hypokalemiaHemoglobinTest');
    hypokalemiaHbA1C: Parameter = new HealthParameter('hypokalemiaHbA1C');
    hypokalemiaRecentEpisode: Parameter = new HealthParameter('hypokalemiaRecentEpisode');
    hypokalemiaTreatmentPlan: Parameter = new HealthParameter('hypokalemiaTreatmentPlan');
    congestionDiagnosisDate: Parameter = new HealthParameter('congestionDiagnosisDate');
    excessiveunderarmsweatingDiagnosisDate: Parameter = new HealthParameter('excessiveunderarmsweatingDiagnosisDate');
    tumorDiagnosisDate: Parameter = new HealthParameter('tumorDiagnosisDate');
    tumorDiagnosisType: Parameter = new HealthParameter('tumorDiagnosisType');
    tumorRemoval: Parameter = new HealthParameter('tumorRemoval');
    tumorTreatmentPlan: Parameter = new HealthParameter('tumorTreatmentPlan');
    heartarrythmiaDiagnosisDate: Parameter = new HealthParameter('heartarrythmiaDiagnosisDate');
    heartarrythmiaEpisode: Parameter = new HealthParameter('heartarrythmiaEpisode');
    heartarrythmiaTreatmentPlan: Parameter = new HealthParameter('heartarrythmiaTreatmentPlan');
    heartarrythmiaAblation: Parameter = new HealthParameter('heartarrythmiaAblation');
    heartarrythmiaSymptoms: Parameter = new HealthParameter('heartarrythmiaSymptoms');
    shinglesDiagnosisDate: Parameter = new HealthParameter('shinglesDiagnosisDate');
    shinglesComplications: Parameter = new HealthParameter('shinglesComplications');
    shinglesComplicationsExplained: Parameter = new HealthParameter('shinglesComplicationsExplained');
    chornicdryeyeDiagnosisDate: Parameter = new HealthParameter('chornicdryeyeDiagnosisDate');
    chornicdryeyePhysicianConsult: Parameter = new HealthParameter('chornicdryeyePhysicianConsult');
    tetanusDiagnosisDate: Parameter = new HealthParameter('tetanusDiagnosisDate');
    erectiledysfunctionDiagnosisDate: Parameter = new HealthParameter('erectiledysfunctionDiagnosisDate');
    erectilediagnosisPhysicianConsult: Parameter = new HealthParameter('erectilediagnosisPhysicianConsult');
    transplantDiagnosis: Parameter = new HealthParameter('transplantDiagnosis');
    transplantDiagnosisDate: Parameter = new HealthParameter('transplantDiagnosisDate');
    transplantTreatmentPlan: Parameter = new HealthParameter('transplantTreatmentPlan');
    coughDiagnosisDate: Parameter = new HealthParameter('coughDiagnosisDate');
    caughCause: Parameter = new HealthParameter('caughCause');
    coughTreatmentPlan: Parameter = new HealthParameter('coughTreatmentPlan');
    coughRecovery: Parameter = new HealthParameter('coughRecovery');
    cirrhosisDiagnosis: Parameter = new HealthParameter('cirrhosisDiagnosis');
    cirrhosisDiagnosisDate: Parameter = new HealthParameter('cirrhosisDiagnosisDate');
    urinaryretentionDiagnosisDate: Parameter = new HealthParameter('urinaryretentionDiagnosisDate');
    urinaryretentionPendingDiagnosis: Parameter = new HealthParameter('urinaryretentionPendingDiagnosis');
    urinaryretentionTreatmentPlan: Parameter = new HealthParameter('urinaryretentionTreatmentPlan');
    urinaryretentionRecovery: Parameter = new HealthParameter('urinaryretentionRecovery');
    gallstonesDiagnosisDate: Parameter = new HealthParameter('gallstonesDiagnosisDate');
    gallstonesPendingDiagnosis: Parameter = new HealthParameter('gallstonesPendingDiagnosis');
    gallstonesTreatmentPlan: Parameter = new HealthParameter('gallstonesTreatmentPlan');
    smokingcessationDiagnosisDate: Parameter = new HealthParameter('smokingcessationDiagnosisDate');
    eatingdisorderDiagnosisDate: Parameter = new HealthParameter('eatingdisorderDiagnosisDate');
    chronichivesDiagnosiDate: Parameter = new HealthParameter('chronichivesDiagnosiDate');
    polypDiagnosisDate: Parameter = new HealthParameter('polypDiagnosisDate');
    polypLocation: Parameter = new HealthParameter('polypLocation');
    polypPendingDiagnosis: Parameter = new HealthParameter('polypPendingDiagnosis');
    polypTreatmentPlan: Parameter = new HealthParameter('polypTreatmentPlan');
    polypBiopsyCompleted: Parameter = new HealthParameter('polypBiopsyCompleted');
    polypBiopsyResults: Parameter = new HealthParameter('polypBiopsyResults');
    polypBiopsySurgery: Parameter = new HealthParameter('polypBiopsySurgery');
    polypRecovery: Parameter = new HealthParameter('polypRecovery');
    obstructiveairwaydiseaseDiagnosisDate: Parameter = new HealthParameter('obstructiveairwaydiseaseDiagnosisDate');
    obstructiveairwaydiseaseTreatmentPlan: Parameter = new HealthParameter('obstructiveairwaydiseaseTreatmentPlan');
    obstructiveairwaydiseaseRecovery: Parameter = new HealthParameter('obstructiveairwaydiseaseRecovery');
    cataplexyDiagnosisDate: Parameter = new HealthParameter('cataplexyDiagnosisDate');
    mesotheliomaDiagnosisDate: Parameter = new HealthParameter('mesotheliomaDiagnosisDate');
    mesotheliomaSymptoms: Parameter = new HealthParameter('mesotheliomaSymptoms');
    mesotheliomaLastEpisode: Parameter = new HealthParameter('mesotheliomaLastEpisode');
    mesotheliomaRecovery: Parameter = new HealthParameter('mesotheliomaRecovery');
    VentricularTachycardia: Parameter = new HealthParameter('VentricularTachycardia');
    VentricularFibrillation: Parameter = new HealthParameter('VentricularFibrillation');
    AtrialFibulationAfib: Parameter = new HealthParameter('AtrialFibulationAfib');
    BloodClotDVTDeepVeinThrombosis: Parameter = new HealthParameter('BloodClotDVTDeepVeinThrombosis');
    Psoriasis: Parameter = new HealthParameter('Psoriasis');
    AnginaChestPain: Parameter = new HealthParameter('AnginaChestPain');
    AVBlock: Parameter = new HealthParameter('AVBlock');
}
